import PageHeader from "../components/PageHeader";
import { useLang } from "../i18n/LanguageProvider";

export default function Cookies() {
  const { t } = useLang();
  return (
    <>
      <PageHeader
        eyebrow={t("page.cookies.eyebrow")}
        title={t("page.cookies.title")}
        lede={t("page.cookies.lede")}
      />
      <section className="pb-24">
        <div className="max-w-3xl mx-auto px-6 lg:px-12 space-y-10 text-white/85 leading-relaxed">
          <div>
            <h2 className="font-serif-display text-2xl text-gold mb-3">What cookies are</h2>
            <p>
              Cookies are small text files placed on your device by websites you visit. They allow
              the site to recognise your device and remember certain information, such as
              preferences or session state.
            </p>
          </div>

          <div>
            <h2 className="font-serif-display text-2xl text-gold mb-3">The cookies we use</h2>
            <div className="border border-[var(--bw-border)] divide-hairline">
              <div className="p-6">
                <div className="text-gold text-xs tracking-[0.32em] uppercase mb-2">Strictly necessary</div>
                <p className="text-sm">
                  Required to load and secure the site (session, security tokens). These cannot be
                  disabled.
                </p>
              </div>
              <div className="p-6">
                <div className="text-gold text-xs tracking-[0.32em] uppercase mb-2">Preference</div>
                <p className="text-sm">
                  Remember interface preferences such as language. These are set only when you
                  interact with a corresponding setting.
                </p>
              </div>
              <div className="p-6">
                <div className="text-gold text-xs tracking-[0.32em] uppercase mb-2">Analytics</div>
                <p className="text-sm">
                  We use only privacy-respecting, aggregated analytics to understand site health.
                  No personal profiling. No advertising cookies. No third-party trackers.
                </p>
              </div>
            </div>
          </div>

          <div>
            <h2 className="font-serif-display text-2xl text-gold mb-3">Managing cookies</h2>
            <p>
              You may block or delete cookies through your browser settings. Doing so may affect
              site functionality. This site does not deploy any advertising, cross-site tracking
              or social-media cookies.
            </p>
          </div>

          <div>
            <h2 className="font-serif-display text-2xl text-gold mb-3">Questions</h2>
            <p>
              For any question relating to this policy, please write to
              <a href="mailto:office@bonworldsingapore.com" className="text-gold hover:underline"> office@bonworldsingapore.com</a>.
            </p>
          </div>
        </div>
      </section>
    </>
  );
}
